import React, { useState, useContext } from "react";
import { Fab, Typography, Grid, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { LangContext } from "../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  textfield: {
    "& .MuiInputBase-input": {
      height: "1.5rem",
      fontWeight: 200,
    },
    marginBottom: "1.5rem",
  },
}));
const Steptwo = ({ setstep, input, setinput }) => {
  const langcontext = useContext(LangContext);
  const lang = langcontext.lang.data;

  const classes = useStyle();
  const [error, setError] = useState({
    statusfname: false,
    first_name: "",
    statuslname: false,
    last_name: "",
    statusphone: false,
    phone: "",
    statusorganization: false,
    organization: "",
    statusaddress: false,
    address: "",
    statusamphoe: false,
    amphoe: "",
    statustambon: false,
    tambon: "",
    statusprovince: false,
    province: "",
    statuscountry: false,
    country: "",
    statuszipcode: false,
    zipcode: "",
  });

  // const [form, setForm] = useState([
  //   { name: "phone", title: "Phone", require: false, value: input.phone },
  //   {
  //     name: "organization",
  //     title: "Organization",
  //     require: false,
  //     value: input.organization,
  //   },
  //   { name: "address", title: "Address", require: false, value: input.address },
  //   {
  //     name: "amphoe",
  //     title: "District",
  //     require: false,
  //     value: input.amphoe,
  //   },
  //   {
  //     name: "tambon",
  //     title: "Subdistrict",
  //     require: false,
  //     value: input.tambon,
  //   },
  //   { name: "province", title: "City", require: false, value: input.province },
  //   { name: "country", title: "Country", require: false, value: input.country },
  //   {
  //     name: "zipcode",
  //     title: "Zip Code",
  //     require: false,
  //     value: input.zipcode,
  //   },
  // ]);

  // const onChange = (e, index) => {
  //   const formvalue = [...form];
  //   formvalue[index].value = e.target.value;
  //   setinput({ ...input, [e.target.name]: e.target.value });
  //   setForm(formvalue);
  // };

  const NextStage = (e) => {
    e.preventDefault();
    setstep(2);
    // const isvalid = validate();
    // if (isvalid) {

    //   console.log(input);
    // } else {
    //   console.log(input);
    // }
  };

  const handleChange = (e) => {
    setinput({ ...input, [e.target.name]: e.target.value });
  };
  return (
    <div>
      <form onSubmit={NextStage}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <TextField
              id={`text_firstname`}
              label={lang.Name}
              name="first_name"
              required
              fullWidth
              className={classes.textfield}
              value={input.first_name}
              onChange={(e) => {
                setinput({ ...input, first_name: e.target.value });
                setError({ ...error, statusfname: false, first_name: "" });
              }}
              error={error.statusfname}
              helperText={error.first_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_lastname`}
              label={lang.Lastname}
              name="last_name"
              required
              fullWidth
              className={classes.textfield}
              value={input.last_name}
              onChange={(e) => {
                setinput({ ...input, last_name: e.target.value });
                setError({ ...error, statuslname: false, last_name: "" });
              }}
              error={error.statuslname}
              helperText={error.last_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_phone`}
              label={lang.Phone}
              name="phone"
              required
              fullWidth
              className={classes.textfield}
              value={input.phone}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusphone: false, phone: "" });
              }}
              error={error.statusphone}
              helperText={error.phone}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_organization`}
              label={lang.Organization}
              name="organization"
              required
              fullWidth
              className={classes.textfield}
              value={input.organization}
              onChange={(e) => {
                handleChange(e);
                setError({
                  ...error,
                  statusorganization: false,
                  organization: "",
                });
              }}
              error={error.statusorganization}
              helperText={error.organization}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_address`}
              label={lang.Address}
              name="address"
              required
              fullWidth
              className={classes.textfield}
              value={input.address}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusaddress: false, address: "" });
              }}
              error={error.statusaddress}
              helperText={error.address}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_amphoe`}
              label={lang.District}
              name="amphoe"
              required
              fullWidth
              className={classes.textfield}
              value={input.amphoe}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusamphoe: false, amphoe: "" });
              }}
              error={error.statusamphoe}
              helperText={error.amphoe}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_tambon`}
              label={lang.Subdistrict}
              name="tambon"
              required
              fullWidth
              className={classes.textfield}
              value={input.tambon}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statustambon: false, tambon: "" });
              }}
              error={error.statustambon}
              helperText={error.tambon}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_city`}
              label={lang.City}
              name="province"
              required
              fullWidth
              className={classes.textfield}
              value={input.province}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statusprovince: false, province: "" });
              }}
              error={error.statusprovince}
              helperText={error.province}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_country`}
              label={lang.Country}
              name="country"
              required
              fullWidth
              className={classes.textfield}
              value={input.country}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statuscountry: false, country: "" });
              }}
              error={error.statuscountry}
              helperText={error.country}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id={`text_zipcode`}
              label={lang.Zipcode}
              name="zipcode"
              required
              fullWidth
              className={classes.textfield}
              value={input.zipcode}
              onChange={(e) => {
                handleChange(e);
                setError({ ...error, statuszipcode: false, zipcode: "" });
              }}
              error={error.statuszipcode}
              helperText={error.zipcode}
            />
          </Grid>

          {/* {form.map((item, index) => {
            return (
              <Grid item xs={6} key={item.title}>
                <TextField
                  id={`text_${item.name}`}
                  label={item.title}
                  name={item.name}
                  required={item.require}
                  fullWidth
                  className={classes.textfield}
                  value={item.value}
                  onChange={(e) => {
                    onChange(e, index);
                  }}
                />
              </Grid>
            );
          })} */}
        </Grid>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Fab
            variant="extended"
            aria-label="signin"
            color="secondary"
            style={{ boxShadow: "unset" }}
            onClick={() => {
              setstep(0);
            }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Back}
            </Typography>
          </Fab>

          <Fab
            variant="extended"
            aria-label="signin"
            color="primary"
            type="submit"
            style={{ boxShadow: "unset" }}
            // onClick={() => {
            //   NextStage();
            // }}
          >
            <Typography variant="h6" component="p" style={{ color: "white" }}>
              {lang.Next}
            </Typography>
          </Fab>
        </div>
      </form>
    </div>
  );
};

export default Steptwo;
